//导入全局统一配置的变量
let projectName=process.env.VUE_APP_PROJECT
let nodeName=process.env.VUE_APP_NODE
export let globalCommonMixin = {
  data(){
    return {
      customPageSizesOptions: [10, 30, 100, 200], // 统一分页选项配置————>每页展示数量选项
      projectName,
      nodeName,
      ossDownList:['https://','weipu-mall-prod.oss-cn-shanghai.aliyuncs.com/','yongjiang-mall.oss-cn-shanghai.aliyuncs.com/']
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/globalCommonMixin.js